import { addLocalePrefix } from 'lib/addLocalePrefix'
import { isUuid } from 'lib/isUuid'
import type { SpaceType } from 'state/ducks/space/models.new'

export type LocationUnitLinkType = 'space' | 'locker_cluster' | 'pudo_locker' | 'coin_locker'

export type BuildSpaceDetailHrefInput = {
  locale?: string
  spaceType: SpaceType | LocationUnitLinkType
  spaceUuid?: string | null
  encryptedId?: string | null
}

function buildLegacySpaceDetailPath(
  spaceType: SpaceType | LocationUnitLinkType,
  encryptedId?: string | null
): string | null {
  const legacyId = encryptedId?.trim()
  if (!legacyId) {
    return null
  }

  switch (spaceType) {
    case 'locker':
    case 'coin_locker':
    case 'multiecube':
    case 'locker_cluster':
      return `/locker/${legacyId}`
    case 'pudo':
    case 'pudo_locker':
      return `/pudo/${legacyId}`
    case 'space':
    case 'normal':
    case 'jr_east':
    case 'japan_post':
    case 'jr_west':
    case 'nta':
    case 'apaman':
      return `/space/${legacyId}`
    default: {
      const exhaustiveCheck: never = spaceType
      return exhaustiveCheck
    }
  }
}

/**
 * スペース詳細ページへの href を生成する。
 * UUID がある場合は `/spaces/{uuid}`、なければ legacy path を返す。
 */
export function buildSpaceDetailHref({
  locale,
  spaceType,
  spaceUuid,
  encryptedId,
}: BuildSpaceDetailHrefInput): string | null {
  const canonicalUuid = spaceUuid?.trim()
  if (isUuid(canonicalUuid)) {
    return addLocalePrefix(`/spaces/${canonicalUuid}`, locale)
  }

  const legacyPath = buildLegacySpaceDetailPath(spaceType, encryptedId)
  if (!legacyPath) {
    return null
  }

  return addLocalePrefix(legacyPath, locale)
}
